<template>
  <div
    class="insights-overview-widgets"
    :class="gridClasses"
  >
    <!-- Row 1: Members Location (full width) -->
    <InsightsMembersLocationWidget v-if="remoteVsOffice" />

    <!-- Row 2: Utilization | Work Time Classification -->
    <InsightsUtilizationWidget />
    <InsightsWorkTimeClassificationWidget />

    <!-- Row 3: Focus Time | Activity -->
    <InsightsFocusTimeWidget />
    <InsightsActivityWidget />

    <!-- Row 4: Start/Stop Time | Idle Time -->
    <InsightsStartStopTimeWidget v-if="showRvoWidgets" />
    <InsightsIdleTimeWidget v-if="showRvoWidgets" />

    <!-- Row 5: Leaderboard (full width) -->
    <InsightsLeaderboardWidget v-if="isTeamDashboard && canSeeTeam" />

    <!-- Row 6: Timeline (full width) -->
    <InsightsTimelineWidget v-if="!isTeamDashboard" />

    <!-- Row 7: Meetings (full width) -->
    <InsightsMeetingsWidget />

    <!-- Row 8: Expenditure (full width) -->
    <InsightsWorkTimeExpenditureWidget />

    <!-- Row 9: Collaboration | Highlights -->
    <InsightsTeamCollaborationWidget />
    <InsightsHighlightsWidget />

    <!-- Row 10: Rankings -->
    <InsightsRankingsWidget />
  </div>
</template>

<script>
import InsightsMembersLocationWidget from '~/components/insights/InsightsMembersLocationWidget.vue';
import InsightsWorkTimeClassificationWidget from '~/components/insights/InsightsWorkTimeClassificationWidget.vue';
import InsightsUtilizationWidget from '~/components/insights/InsightsUtilizationWidget.vue';
import InsightsActivityWidget from '~/components/insights/InsightsActivityWidget.vue';
import InsightsHighlightsWidget from '~/components/insights/InsightsHighlightsWidget.vue';
import InsightsFocusTimeWidget from '~/components/insights/InsightsFocusTimeWidget.vue';
import InsightsLeaderboardWidget from '~/components/insights/InsightsLeaderboardWidget.vue';
import InsightsMeetingsWidget from '~/components/insights/InsightsMeetingsWidget.vue';
import InsightsWorkTimeExpenditureWidget from '~/components/insights/InsightsWorkTimeExpenditureWidget.vue';
import InsightsTeamCollaborationWidget from '~/components/insights/InsightsTeamCollaborationWidget.vue';
import InsightsIdleTimeWidget from '~/components/insights/InsightsIdleTimeWidget.vue';
import InsightsTimelineWidget from '~/components/insights/InsightsTimelineWidget.vue';
import InsightsRankingsWidget from '~/components/insights/InsightsRankingsWidget.vue';
import InsightsStartStopTimeWidget from '~/components/insights/InsightsStartStopTimeWidget.vue';

import { mapGetters } from 'vuex';

export default {
  name: 'InsightsOverviewWidgets',
  components: {
    InsightsRankingsWidget,
    InsightsTimelineWidget,
    InsightsMembersLocationWidget,
    InsightsWorkTimeClassificationWidget,
    InsightsUtilizationWidget,
    InsightsActivityWidget,
    InsightsHighlightsWidget,
    InsightsFocusTimeWidget,
    InsightsLeaderboardWidget,
    InsightsMeetingsWidget,
    InsightsWorkTimeExpenditureWidget,
    InsightsTeamCollaborationWidget,
    InsightsIdleTimeWidget,
    InsightsStartStopTimeWidget,
  },
  computed: {
    ...mapGetters(['collaborationsUnavailable', 'remoteVsOffice', 'showRvoWidgets', 'isTeamDashboard', 'canSeeTeam']),
    gridClasses() {
      return {
        'has-collaborations': !this.collaborationsUnavailable
      };
    },
  },
};
</script>
